import React, { useState, useEffect } from 'react';
import { Zap, Activity, TrendingUp, AlertCircle } from 'lucide-react';
import Layout from '../components/Layout';
import Loading from '../components/Loading';
import { analysisService } from '../services/api';

const AutoTradingAnalysisPage = () => {
  const [data, setData] = useState(null);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const loadData = async () => {
      try {
        const response = await analysisService.getSchedulerStatus();
        setData(response.data);
      } catch (error) {
        console.error('Auto trading analysis load error:', error);
      } finally {
        setIsLoading(false);
      }
    };

    loadData();
  }, []);

  if (isLoading) {
    return (
      <Layout>
        <Loading message="자동매매 분석 데이터를 불러오는 중..." />
      </Layout>
    );
  }

  return (
    <Layout>
      <div className="space-y-6">
        <div>
          <h1 className="text-2xl font-bold text-gray-900">🤖 자동매매 분석</h1>
          <p className="text-gray-600">실시간 자동매매 시스템을 모니터링하세요</p>
        </div>

        {/* 시스템 상태 */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          <div className="bg-white rounded-lg shadow p-6">
            <div className="flex items-center justify-between">
              <div>
                <p className="text-sm text-gray-600">자동매매 상태</p>
                <p className={`text-xl font-bold ${data?.is_running ? 'text-green-600' : 'text-red-600'}`}>
                  {data?.is_running ? 'ON' : 'OFF'}
                </p>
              </div>
              <Zap className={`w-8 h-8 ${data?.is_running ? 'text-green-500' : 'text-red-500'}`} />
            </div>
          </div>

          <div className="bg-white rounded-lg shadow p-6">
            <div className="flex items-center justify-between">
              <div>
                <p className="text-sm text-gray-600">오늘 주문</p>
                <p className="text-xl font-bold text-gray-900">{data?.today_orders || 0}건</p>
              </div>
              <Activity className="w-8 h-8 text-blue-500" />
            </div>
          </div>

          <div className="bg-white rounded-lg shadow p-6">
            <div className="flex items-center justify-between">
              <div>
                <p className="text-sm text-gray-600">성공률</p>
                <p className="text-xl font-bold text-gray-900">{data?.success_rate || '0.00'}%</p>
              </div>
              <TrendingUp className="w-8 h-8 text-purple-500" />
            </div>
          </div>
        </div>

        {/* 안내 메시지 */}
        <div className="bg-blue-50 border border-blue-200 rounded-lg p-4">
          <div className="flex items-center space-x-3">
            <AlertCircle className="w-5 h-5 text-blue-600" />
            <p className="text-blue-800">
              자동매매 분석 기능이 개발 중입니다. 더 자세한 분석은 종합 AI 대시보드를 이용해주세요.
            </p>
          </div>
        </div>
      </div>
    </Layout>
  );
};

export default AutoTradingAnalysisPage;